module.exports = __webpack_public_path__ + "static/media/create_reservation_list.813f417b.jpg";